export default __webpack_public_path__ + "static/media/4.5d088f65.jpg";